class LargeVideoV2 extends HTMLElement {
  static get tagName() {
    return 'large-video-v2';
  }

  constructor() {
    super();
    this.hasAutoPlayed = false;
    this.boundPlay = this.playVideo.bind(this);
  }

  connectedCallback() {
    this.coverElement = this.querySelector('.video-cover');
    this.iframeContainer = this.querySelector('.video-iframe');
    this.videoContainer = this.querySelector('.video-container');

    if (!this.coverElement || !this.iframeContainer || !this.videoContainer) return;

    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.prefersReducedMotion) {
      this.coverElement.addEventListener('click', this.boundPlay);
    } else if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.hasAutoPlayed) {
              setTimeout(() => this.playVideo(), 500);
            }
          });
        },
        { threshold: 0.5 }
      );
      this.observer.observe(this.videoContainer);
    }
  }

  disconnectedCallback() {
    if (this.prefersReducedMotion && this.coverElement) {
      this.coverElement.removeEventListener('click', this.boundPlay);
    }
    if (this.observer && this.videoContainer) {
      this.observer.unobserve(this.videoContainer);
    }
  }

  playVideo() {
    const youtubeUrl = this.videoContainer.dataset.video;
    const videoId = youtubeUrl?.match(
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
    )?.[1];

    if (!videoId || this.hasAutoPlayed) return;

    this.hasAutoPlayed = true;
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&playsinline=1`;
    iframe.frameBorder = '0';
    iframe.allow = 'autoplay; encrypted-media';
    iframe.allowFullscreen = true;
    iframe.title = this.videoContainer.dataset.title || 'Video';

    this.iframeContainer.appendChild(iframe);
    this.iframeContainer.style.display = 'block';
    this.coverElement.style.display = 'none';

    const badge = this.querySelector('.js-video-badge');
    if (badge) badge.style.opacity = '0';
  }
}

customElements.define(LargeVideoV2.tagName, LargeVideoV2);
